<template>
  <div class="content-box cr-inicio">
    <div class="element-wrapper">
      <div class="element-box cr-caja">
        <!-- Regresa al submenu de donde se entro (POS o Inventario) sin usar el boton atras del equipo -->
        <!-- Mismo estilo que "Ver todos los Requerimientos" -->
        <button type="button" class="btn btn-sm btn-info d-inline-flex align-items-center cr-btn-regresar"
          @click="volverMenu">
          <i class="os-icon os-icon-chevrons-left sliding-icon"></i>
          <span class="ml-1">Regresar al menú</span>
        </button>
        <div class="cr-cabecera">
          <!-- El tipo lo define la opcion del menu: POS (factura) o Inventario (requerimiento) -->
          <h5 class="form-header mb-0">
            Cotizaciones de {{ tipo === TIPO_FACTURA ? "factura" : "requerimiento" }}
          </h5>
          <!-- En movil se usa el boton flotante verde de abajo -->
          <button type="button" class="btn btn-success d-none d-md-inline-block" @click="abrirModal">
            <i class="fa fa-plus"></i>
            Nueva
          </button>
        </div>

        <div class="input-group mb-3">
          <input v-model="busqueda" class="form-control" placeholder="NIT, nombre o número" type="text"
            @keyup.enter="buscar" />
          <div class="input-group-append">
            <button type="button" class="btn btn-dark" @click="buscar">
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>

        <div v-if="cargando && registros.length === 0" class="text-center text-muted py-3">Cargando...</div>
        <div v-else-if="registros.length === 0" class="text-center text-muted py-3">
          No hay cotizaciones para mostrar.
        </div>

        <!-- Las vencidas se muestran opacas para distinguirlas de las vigentes -->
        <button v-for="item in registros" :key="item.id" type="button" class="cr-item"
          :class="{ 'cr-item-vencida': item.esta_vencida }" @click="abrir(item)">
          <div class="cr-item-fila">
            <b>#{{ item.numero }}</b>
            <span class="badge" :class="claseEstado(item.estado)">{{ textoEstado(item) }}</span>
          </div>
          <div class="cr-item-cliente">{{ nitCliente(item) }} - {{ item.cliente_nombre }}</div>
          <div class="cr-item-fila">
            <small class="text-muted">
              {{ item.fecha }} &middot; {{ nombreTienda(item) }}
              <span v-if="item.esta_vencida" class="text-danger"> &middot; Vencida</span>
            </small>
            <b class="text-success">Q {{ formatearMonto(item.total) }}</b>
          </div>
        </button>

        <button v-if="siguientePagina" type="button" class="btn btn-outline-secondary btn-block mt-2"
          @click="cargarMas" :disabled="cargando">
          {{ cargando ? "Cargando..." : "Ver más" }}
        </button>
      </div>
    </div>

    <!-- Boton flotante (solo movil) al centro inferior, como "Nuevo Conteo" pero en verde -->
    <button type="button" class="floated-chat-btn cr-btn-nueva d-md-none" @click="abrirModal">
      <i class="fa fa-plus"></i>&nbsp;Nueva
    </button>

    <NuevaCotizacionMovilModal ref="modal" @creada="onCreada" @cerrado="onCerradoModal" />
  </div>
</template>

<script>
import NuevaCotizacionMovilModal from "./NuevaCotizacionMovilModal";
import Notifications from "@/notifications/notifications";
import CotizacionMovilService, {
  TIPO_FACTURA,
  TIPO_REQUERIMIENTO,
} from "@/services/cxc/CotizacionMovilService";

/**
 * Listado del modulo de cotizaciones moviles (handheld). El tipo lo define la
 * opcion del menu: POS (?tipo=factura) o Inventario (?tipo=requerimiento).
 */
export default {
  name: "CotizacionMovilComponent",
  components: {
    NuevaCotizacionMovilModal,
  },
  data() {
    return {
      TIPO_FACTURA,
      TIPO_REQUERIMIENTO,
      tipo: this.tipoDesdeRuta(),
      busqueda: "",
      registros: [],
      pagina: 1,
      siguientePagina: false,
      cargando: false,
    };
  },
  watch: {
    // Desde Inventario se entra con ?tipo=requerimiento y desde POS con ?tipo=factura.
    // ?nueva=1 (boton "Nueva cotizacion" de la pantalla de escaneo) abre el modal.
    "$route.query": function () {
      this.tipo = this.tipoDesdeRuta();
      this.busqueda = "";
      this.cargar(true);
      this.abrirModalSiSePidio();
    },
  },
  mounted() {
    this.cargar(true);
    this.abrirModalSiSePidio();
  },
  methods: {
    tipoDesdeRuta() {
      return this.$route.query.tipo === TIPO_REQUERIMIENTO ? TIPO_REQUERIMIENTO : TIPO_FACTURA;
    },
    abrirModal() {
      this.$refs.modal.abrir(this.tipo);
    },
    volverMenu() {
      // Nombres de modulo del menu (store): "pos" para factura, "inv" para requerimiento
      this.$router.push({
        name: "dashboard",
        query: { modulo: this.tipo === TIPO_FACTURA ? "pos" : "inv" },
      });
    },
    abrirModalSiSePidio() {
      if (this.$route.query.nueva) {
        this.abrirModal();
      }
    },
    onCerradoModal() {
      // Se quita ?nueva=1 para que al regresar a esta pantalla no se vuelva a abrir el modal
      if (this.$route.query.nueva) {
        this.$router.replace({ name: "pos-cotizacion-movil", query: { tipo: this.tipo } });
      }
    },
    onCreada(evento) {
      this.$router.push({
        name: "pos-cotizacion-movil-escaneo",
        params: { tipo: evento.tipo, id: evento.id },
      });
    },
    buscar() {
      this.cargar(true);
    },
    cargarMas() {
      this.pagina += 1;
      this.cargar(false);
    },
    cargar(reiniciar) {
      if (reiniciar) {
        this.pagina = 1;
        this.registros = [];
      }
      const tipo = this.tipo;
      this.cargando = true;
      CotizacionMovilService.listar(tipo, {
        page: this.pagina,
        "filter[search]": (this.busqueda || "").trim(),
      })
        .then((response) => {
          if (this.tipo !== tipo) {
            return;
          }
          const data = response.data || {};
          const resultados = Array.isArray(data) ? data : data.results || [];
          this.registros = this.registros.concat(resultados);
          this.siguientePagina = !Array.isArray(data) && !!data.next;
        })
        .catch(() => {
          Notifications.toast.error("Cotizaciones", "No se pudo cargar el listado");
        })
        .finally(() => {
          this.cargando = false;
        });
    },
    /**
     * Siempre se abre la vista movil (pestanas Productos / Cliente). Si ya no es
     * editable se muestra en solo lectura; el modulo completo queda en el boton
     * "Abrir en el modulo completo".
     */
    abrir(item) {
      this.$router.push({
        name: "pos-cotizacion-movil-escaneo",
        params: { tipo: this.tipo, id: item.id },
      });
    },
    nitCliente(item) {
      if (item.cliente_nit) {
        return item.cliente_nit;
      }
      return item.cliente && item.cliente.nit ? item.cliente.nit : "";
    },
    nombreTienda(item) {
      if (item.tienda_nombre) {
        return item.tienda_nombre;
      }
      return item.tienda && item.tienda.nombre ? item.tienda.nombre : "";
    },
    textoEstado(item) {
      const textos = { A: "Abierta", B: "Cerrada", E: "Impresa", 9: "Anulada" };
      // Otros estados del pedido (ej. H = despachada) se toman del backend
      return textos[item.estado] || item.estado_str || item.estado;
    },
    claseEstado(estado) {
      return {
        "badge-success": estado === "A",
        "badge-warning": !!estado && estado !== "A" && estado !== "9",
        "badge-danger": estado === "9",
      };
    },
    formatearMonto(valor) {
      const numero = Number(valor || 0);
      return numero.toLocaleString("es-GT", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
  },
};
</script>

<style scoped>
.cr-caja {
  padding: 12px 16px;
}

.cr-btn-nueva {
  /* Centrado sin transform: la animacion jumpUp del tema usa transform */
  left: 0;
  right: 0;
  bottom: 14px;
  /* Debajo del modal de nueva cotizacion (1050); el tema usa 9999 */
  z-index: 1040;
  margin: 0 auto;
  width: max-content;
  border: 0;
  font-family: inherit;
  font-weight: bold;
  background: #28a745;
  box-shadow: 0 2px 20px 0 rgba(40, 167, 69, 0.75);
}

.cr-btn-nueva:hover,
.cr-btn-nueva:focus {
  background: #218838;
  color: #fff;
}

.cr-btn-regresar {
  margin-bottom: 10px;
  min-height: 36px;
}

.cr-cabecera {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.cr-item {
  display: block;
  width: 100%;
  text-align: left;
  background-color: #fff;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 8px;
}

.cr-item:active,
.cr-item:hover {
  background-color: #f3f7ff;
}

.cr-item-vencida {
  background-color: #f1f1f1;
  border-color: #dcdcdc;
  opacity: 0.6;
}

.cr-item-vencida:active,
.cr-item-vencida:hover {
  background-color: #e9e9e9;
}

.cr-item-fila {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cr-item-cliente {
  font-size: 0.9rem;
  margin: 2px 0;
  overflow-wrap: anywhere;
}

.form-control {
  min-height: 44px;
}

@media (max-width: 767px) {
  .cr-inicio {
    /* Espacio inferior para que el boton flotante no tape la ultima cotizacion */
    padding: 8px 8px 96px !important;
  }

  .cr-caja {
    padding: 10px;
  }
}
</style>
